import styled from "styled-components";

export const ModalBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
`;

export const ModalContainer = styled.div`
  font-family: "Nunito";
  background: white;
  padding: 30px 40px;
  border-radius: 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
